"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _GridContainer = _interopRequireDefault(require("./GridContainer"));

var _GridElement = _interopRequireDefault(require("./GridElement"));

var _GridWrapper = _interopRequireDefault(require("./GridWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 *      Grid system allows quick creation of responsive grid based systems. Includes
 *      a Container and an element that takes a columns prop that can either be a
 *      set column or an array to change column widths responsively.
 *
 *    // Theme setup required for GridSystem
 *    grid: {
 *      // Number of columns at each breakpoint
 *      columns: [6, 8, 12, 12, 12, 12],
 *      // Gutters between columns at each breakpoint
 *      gutters: ["4px", "8px", "12px", "12px", "12px", "16px"],
 *      // Side margins at each breakpoint
 *      margins: [3, 5, 5, 7],
 *      // Maximum width of Grid
 *      maxWidth: 1420
 *    }
 *
 *    <GridSystem.Wrapper> // Main section container -- handles maxwidth -- side gutters -- background images
 *      <GridSystem.Container> // Row -- counteracts column outer padding
 *        <GridSystem.Element columns={[6, 8, 4]}>// Column</GridSystem.Element> // Column -- handles gutters -- responsive widths
 *        <GridSystem.Element columns={[6, 8, 4]}>// Column</GridSystem.Element>
 *        <GridSystem.Element columns={[6, 8, 4]}>// Column</GridSystem.Element>
 *      </GridSystem.Container>
 *      <GridSystem.Container> // Row -- counteracts column outer padding
 *        <GridSystem.Element columns={[6, 8, 3]}>// Column</GridSystem.Element> // Column -- handles gutters -- responsive widths
 *        <GridSystem.Element columns={[6, 8, 3]}>// Column</GridSystem.Element>
 *        <GridSystem.Element columns={[6, 8, 3]}>// Column</GridSystem.Element>
 *        <GridSystem.Element columns={[6, 8, 3]}>// Column</GridSystem.Element>
 *      </GridSystem.Container>
 *    </GridSystem.Wrapper>
 */
var GridSystem = {
  Container: _GridContainer["default"],
  Element: _GridElement["default"],
  Wrapper: _GridWrapper["default"]
};
var _default = GridSystem;
exports["default"] = _default;